import React from 'react';
import './Hexagon.sass';

import cx from 'classnames';

export default class Hexagon extends React.PureComponent {
  render() {
    const {children, bordered} = this.props;

    return (
      <div className={cx("hexagon", bordered && "hexagon--bordered")}>
        {bordered ? (
          <div className="hexagon__border">
            <div className="hexagon__box">
              {children}
            </div>
          </div>
          ) : (
          <div className="hexagon__box">
            {children}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/hexagon/Hexagon.js